import type { ResourcePointHeritageDescription } from "../types";

type ResourcePointHeritageDescriptionFieldsProps = {
  value: ResourcePointHeritageDescription;
  error?: string;
  onChange: (value: ResourcePointHeritageDescription) => void;
};

const fields: Array<{
  key: keyof ResourcePointHeritageDescription;
  label: string;
  placeholder: string;
}> = [
  { key: "brief", label: "简介", placeholder: "介绍非遗项目背景、特色与体验亮点" },
  { key: "visitFlow", label: "参观流程", placeholder: "按顺序说明参观环节与注意事项" },
  { key: "experienceFlow", label: "体验流程", placeholder: "按顺序说明动手体验环节" },
  { key: "priceOther", label: "价格及其他", placeholder: "价格说明、预约要求或其他补充信息" },
];

/** 非遗描述四段文案：上标签下文本框布局。 */
export function ResourcePointHeritageDescriptionFields({
  value,
  error,
  onChange,
}: ResourcePointHeritageDescriptionFieldsProps) {
  return (
    <section className="resource-point-heritage-description-editor" data-testid="heritage-description-editor">
      {fields.map((field) => (
        <label key={field.key} className="resource-point-heritage-description-editor__field">
          <span className="resource-point-heritage-description-editor__label">{field.label}</span>
          <textarea
            className="resource-point-heritage-description-editor__textarea"
            aria-label={field.label}
            placeholder={field.placeholder}
            value={value[field.key]}
            onChange={(event) => onChange({ ...value, [field.key]: event.target.value })}
          />
        </label>
      ))}
      {error ? (
        <div className="resource-point-form-error" role="alert">{error}</div>
      ) : null}
    </section>
  );
}
